import { createReducer, on } from '@ngrx/store';
import { SearchState } from '../../../../models';
import { DataFilterAction } from '../../../actions';
import { SearchHelper } from '../../../utils';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function searchReducerFactory(searchHelper: SearchHelper) {
  const initialState: SearchState = {
    searchableData: {},
    searchedValue: null,
    searchOverlaps: null,
    searchFilteredDataIds: null,
    shouldCalculateOnDataChange: true,
  };

  return createReducer(
    initialState,
    on(DataFilterAction.definitionStateBuilt, (state, action) => {
      const searchedValue = action.searchedValue?.trim() || '';
      const searchOverlaps = searchHelper.calculateSearchOverlaps(searchedValue, action.searchableData);

      if (state.shouldCalculateOnDataChange) {
        return {
          ...state,
          shouldCalculateOnDataChange: false,
          searchedValue: searchedValue,
          searchableData: action.searchableData,
          searchOverlaps,
          searchFilteredDataIds: searchOverlaps ? Object.keys(searchOverlaps) : null,
        };
      }

      return {
        ...state,
        searchedValue: searchedValue,
        searchableData: action.searchableData,
        searchOverlaps,
      };
    }),
    on(DataFilterAction.forceCalculation, (state, _) => {
      return {
        ...state,
        searchFilteredDataIds: state.searchOverlaps ? Object.keys(state.searchOverlaps) : null,
      };
    }),
    on(DataFilterAction.search, (state, action) => {
      const searchedValue = action.searchValue?.trim() || '';

      if (state.searchedValue === searchedValue) {
        return state;
      }

      if (!searchedValue || !state.searchableData) {
        return {
          ...state,
          searchedValue: null,
          searchOverlaps: null,
          searchFilteredDataIds: null
        };
      }

      const searchOverlaps = searchHelper.calculateSearchOverlaps(searchedValue, state.searchableData);

      return {
        ...state,
        searchOverlaps,
        searchedValue: searchedValue,
        searchFilteredDataIds: searchOverlaps ? Object.keys(searchOverlaps) : null
      };
    }),
    on(DataFilterAction.resetSearch, (state) => {
      return {
        ...state,
        searchedValue: null,
        searchOverlaps: null,
        searchFilteredDataIds: null,
      };
    })
  );
}
